import { BarGraphIcon } from 'taboola-ultimate-ui';
import { GRAPHS } from 'modules/campaigns/constants/graphTypes';
import CampaignGraphTooltip from '../../../components/Tooltips/CampainGraphTooltip';
import * as FIELDS from '../../fields';
import metrics from '../../metrics';

const barGraph = {
    type: GRAPHS.BAR,
    endpoint: 'campaign-report-by-campaign-daily',
    metrics: [
        metrics.SPENT,
        metrics.VIDEO_VISIBLE_IMPRESSIONS,
        metrics.VIDEO_IMPRESSIONS,
        metrics.CLICKS,
        metrics.VIDEO_VCTR,
        metrics.VIDEO_CTR,
        metrics.AVERAGE_CPC,
        metrics.CVR,
        metrics.CVR_CLICKS,
        metrics.CVR_VIEWS,
        metrics.CONVERSIONS,
        metrics.CONVERSIONS_CLICKS,
        metrics.CONVERSIONS_VIEWS,
        metrics.CPA,
        metrics.CPA_CLICKS,
        metrics.CPA_VIEWS,
        metrics.VIDEO_CPM,
        metrics.VIDEO_VCPM,
        metrics.CONVERSIONS_VALUE,
        metrics.ROAS,
        metrics.CPCV,
        metrics.VIEWABILITY_RATE,
        metrics.COMPLETION_RATE,
        metrics.HUNDRED_PCT_VIEWABILITY_RATE,
        metrics.COMPLETED_VIEWS,
        metrics.UNIQUE_IMPRESSIONS,
        metrics.UNIQUE_VIEWABLE_IMPRESSIONS,
        metrics.UNIQUE_CLICKS,
    ],
    maxAllowedSelectedMetrics: 4,
    maxXAxisValues: 8,
    shouldUseGridDataSrc: true,
    displayTotalsInLegendRow: false,
    enableLongTextTickFormatting: true,
    graphProps: {
        xAxisDataKey: FIELDS.NAME.field,
    },
    graphTooltip: CampaignGraphTooltip,
    graphToggleIcon: BarGraphIcon,
};

export const graph = [barGraph];
